import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { getWorkOrderAccessPanels } from '../api';
import UserSelfContext from '../utils/self-context';
import AccessPanelsList from '../components/AccessPanelsList';

const AccessPanelsWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const ListWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow:  auto;
	width: 100%;
	background: #f0f2f5;
`;

function AccessPanels(props) {
	const {
		workOrderId,
		stats
	} = props;
	const [loading, setLoading] = useState(true);
	const [err, setErr] = useState(false);
	const [accessPanels, setAccessPanels] = useState([]);
	const { userSelf } = useContext(UserSelfContext);

	async function fetchAccessPanels() {
		setLoading(true);

		try {
			const data = await getWorkOrderAccessPanels(workOrderId);
			setAccessPanels(data);
		} catch (e) {
			setErr(true);
		}

		setLoading(false);
	}

	useEffect(() => {
		if (workOrderId) {
			fetchAccessPanels();
		}
	}, [workOrderId]);

	return (
		<AccessPanelsWrapper>
			<ListWrapper>
				<AccessPanelsList
					stats={stats}
					loading={loading}
					accessPanels={accessPanels}
					workOrderId={workOrderId}
				/>
			</ListWrapper>
		</AccessPanelsWrapper>
	);
}

export default AccessPanels;
